export default "__VITE_ASSET__bc08e954__"